import { media } from '../../styles/styled-components'
import styled from 'styled-components'

export default styled.p`
  font-size: 1.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  line-height: 1.6;
  text-align: ${ ({ scAlignTextToLeft }) => scAlignTextToLeft ? 'left' : 'center' };
  a {
    color: ${ ({ theme }) => theme.colors.red };
  }
  ${ media.tablet`
    font-size: 2.2rem;
  ` }

  ${ media.desktop`
    font-size: 2.8rem;
    text-align: left;
    text-align: ${ ({ scAlignTextToCenter }) => scAlignTextToCenter ? 'center' : 'left' }
  ` }
`
